module.exports = require("core-js/library/fn/get-iterator");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/get-iterator.js
// module id = 80
// module chunks = 0 2